var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ss-activity-detail',{attrs:{"showRecmd":false}})}
var staticRenderFns = []

export { render, staticRenderFns }